import './App.css';
import { Link } from 'react-router-dom'
import React, {useState,useEffect} from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {auth} from './firebase-config'
import { collection,onSnapshot , getDoc,doc, getDocs,getFirestore, setDoc } from "firebase/firestore"
import { Chat } from "./Chat"
import { Send } from "./Send"

export function Side (props){
    const db = getFirestore()
    const [topic,setTopic] = useState('Introduction')
    const [topicList,setTopicList] = useState([])
    const [isAdd,setisAdd] = useState(false)
    const [messages,setMessages] =useState([])
    function changeTopic(string){
      setTopic(current =>{
      
        return string;
      })
    }

    
    // for topic
    async function getDocuments(db){
        const querySnapshot = await getDocs(collection(db,"topics"));
        querySnapshot.forEach((doc) => {
          setTopicList(current=>{
            return [...current,`#${doc.id}`]})
        });
    }
    useEffect(()=>{
    if (props?.name!=='' &&topic){
    getDocuments(db)
    }
   }
  ,[props.name])
  
  useEffect(() => {
    const getTopics = () => {
      const unsub = onSnapshot(collection(db, "topics"), (snapshot) => {
        setTopicList([])
        snapshot.forEach((doc)=>{
          setTopicList((current)=>{
          return [...current,`#${doc.id}`]
          })
        })
        })

      return () => {
        unsub();
      };
    }
      topic && getTopics();

    },[props.name]);
    
  
 

  if (props?.name!==''){
    function showInput (){
    const input = document.querySelector('.add-input-div')
    const add = document.querySelector('.add')
    input.style.display='flex'
    add.style.display='none'
    }
    function cancel (){
      const input = document.querySelector('.add-input-div')
    const add = document.querySelector('.add')
    input.style.display='none'
    add.style.display='block'
    }
    async function submit(){
      const addInput = document.querySelector('.add-input')
      const text = addInput.value;
      await setDoc(doc(db,'topics',text),{
  
      })
      addInput.value=''
      props.setIsAdd(true)
      cancel()
  
    }

return (
<div>
<div className='topics'>
       <ul className='topic-list'>
        {topicList.map((t,i)=>(
          <li className='topic' key={i} onClick={(e)=>changeTopic(e.target.innerText.slice(1,))}>
            {t}
          </li>
                ))}
       </ul>
       <div className='add-div'>
       <div className='add-input-div' style={{display:'none'}}> 
        <input className='add-input' placeholder='new topic...' type='text'/>
        <button className='green' onClick={submit} >Add</button>
        <button className='red' onClick={cancel}>Cancel</button>
       </div>
       <button className='add' onClick={showInput}>+</button>
       </div>
    </div>
    <Chat 
      url = {props.url}
      name= {props.name}
      topic= {topic}
      />
      <Send
       name={props.name}
       url={props.url}
       uid={props.uid}
       topic={topic}
        />
    </div>
       )
  }}